import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

class Salesdonut extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        chart: {
          type: "donut",
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        tooltip: {
          y: {
            formatter: () => "" 
          }
        },
        plotOptions: {
          pie: {
            donut: {
              size: "75%",
            },
          },
        },
        colors: ["#626ed4", "#02a499", "#38a4f8", "#f8b425", "#ff4560", "#93b4a1"],
        labels: ["Fees 1", "Fees 2", "Fees 3", "Fees 4", "Fees 5", "Fees 6"], 
      },
    };
  }

  render() {
    return (
      <ReactApexChart
        options={this.state.options}
        series={this.props.series}
        type="donut"
        height="220"
      />
    );
  }
}

export default Salesdonut;